"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductDetails = exports.getIsLoading = exports.pathToProductState = void 0;

var _ramda = require("ramda");

var pathToProductState = function pathToProductState(state) {
  return state.createGift.product;
};

exports.pathToProductState = pathToProductState;
var getIsLoading = (0, _ramda.pipe)(pathToProductState, function (state) {
  return state.isLoading;
});
exports.getIsLoading = getIsLoading;
var getProductDetails = (0, _ramda.pipe)(pathToProductState, function (state) {
  return state.product;
});
exports.getProductDetails = getProductDetails;